import { Component, ViewContainerRef, ViewChild } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel } from '@angular/router';
import { TooltipSettings } from '@progress/kendo-angular-tooltip';
import { SpinnerService } from './shared/services/spinner.service';
import { Constants } from './shared/models/constants';
import { LoaderType } from './shared/enums/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [{
    provide: TooltipSettings,
    useFactory: (): TooltipSettings => ({
      callout: false,
      closeTitle: ""
    })
  }]
})
export class AppComponent {
  title = 'Field Service';
  constructor(private router: Router, private showspinner: SpinnerService,private viewContainerRef: ViewContainerRef) {
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.showspinner.showloader(this.viewContainerRef, Constants.FixedtabCounters.appComponent, 0, false, 0, LoaderType.circle);
      } else if (event instanceof NavigationEnd) {
        this.showspinner.hideLoader(this.viewContainerRef, Constants.FixedtabCounters.appComponent)
      }
      else if (event instanceof NavigationCancel) {
        this.showspinner.hideLoader(this.viewContainerRef, Constants.FixedtabCounters.appComponent)
      }
    });
  }
}
